import React from 'react';
import { Link } from 'react-router-dom'; // Import the Link component from React Router
import eventsData from '../../data/eventsData.json';
// import blogImg1 from '/images/events/MboaAccess.png'
// import blogImg2 from '/images/events/MboaTicket.png'
import blogImg3 from '../../assets/images/blog/blog-2-3.jpg'

const blogPosts = [
  {
    date: "Oct 25",
    title: "Clear value proposition and actionable steps",
    imgSrc: "/images/events/MboaTicket.png",
    describe : "À l’ère du numérique, la billetterie exclusivement classique freine la performance de vos  événements. La solution MBOATICKET gère l’ensemble du cycle de production et de sécurisation des tickets de vos évènement, de la création à la vente à l’entrée physique/numérique. Grâce à une billetterie intelligente, les risques de fraude sont réduits, les coûts logistiques supprimés et chaque vente est suivie en temps réel. Adopter MBOATICKET c’est l’assurance d’une meilleure expérience pour le public, moins de pertes, plus de contrôle, et une rentabilité optimisée pour les organisateurs.",
    link: "/blog-details",
    comments: 5,
    author: "admin",
  },
  {
    date: "Oct 19",
    title: "This piques curiosity and makes readers want",
    imgSrc: "/images/events/MboaAccess.png",
    describe : "Système de contrôle d’accès par scan QR Code. Validation rapide et fiable des billets à l’entrée. Gestion intelligente des flux pour réduire les files d’attente. Prévention de la fraude et des accès non autorisés. Tableau de bord de suivi des ventes et des entrées en direct. Statistiques détaillées pour une meilleure prise de décision. Export des données après événement pour analyse et reporting.",
    link: "/blog-details",
    comments: 5,
    author: "admin",
  },
 
];
const testimonials = [
  {
    clientName: "Jonathon Doe",
    role: "Officer",
    clientImage: "images/events/mulema_1.jpg",
    text: "Events are special occasions where people gather together to celebrate, commemorate, or participate in a specific purpose or theme.",
    rating: 4,
  },
];

export default function BlogTwo() {
  return (
    <section id="th-blog" className="blog-two">
      <div className="container">
        <div className="section-title text-center">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">BILLETTERIE, CONTRÔLE D'ACCÈS</span>
          </div>
          <h2 className="section-title__title section-title__title--two">
            Découvrez Nos Solutions
          </h2>
        </div>
        <div className="row">
          {blogPosts.map((post, index) => (
            <div
              key={index}
              className={`col-xl-6 col-lg-6 col-md-6 wow fadeIn${index % 2 === 0 ? "Left" : "Right"}`}
              data-wow-delay={`${100 + index * 100}ms`}
            >
              <div className="blog-two__single">
                <div className="blog-two__img">
                  <img src={post.imgSrc} alt={post.title} />
                  {/* <div className="blog-two__hover">
                    <Link to="/">
                      <div className="blog-two__hover-icon-1">
                        <span className="blog-two__hover-icon-2"></span>
                      </div>
                    </Link>
                  </div> */}
                  {/* <div className="blog-two__date">
                    <p>{post.date}</p>
                  </div> */}
                </div>
                <div className="blog-two__content">
                  {/* <ul className="blog-two__meta list-unstyled">
                    <li>
                      <Link to="#"><span className="icon-user"></span>By {post.author}</Link>
                    </li>
                    <li>
                      <Link to="#"><span className="icon-comments"></span>Comments ({post.comments})</Link>
                    </li>
                  </ul> */}
                  {/* <h3 className="blog-two__title">
                    <Link to={post.link}>{post.title}</Link>
                  </h3> */}
                  <p>{post.describe}</p>
                  {/* <div className="blog-two__btn-box-two">
                    <Link to="#" className="blog-two__btn thm-btn">
                      Read More<span className="icon-arrow-right"></span>
                    </Link>
                  </div> */}
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
